/**
 * @param {number} number 
 * @returns {string} The result does not include the number
 */
const getOutOfRangeText = (number) => {
  return `item${(number === 0 || number > 1) ? "s" : ""} out of range`;
};

export { getOutOfRangeText };